import { MenuItemWithIcon } from "@msys/ui";
import { FileCopy as FileCopyIcon } from "@mui/icons-material";
import { useTranslate } from "@tolgee/react";
import { useNavigate } from "react-router-dom";
import { useDuplicateQuote } from "../hooks/useDuplicateQuote.js";

interface Props {
  pathToDocList: string;
  docId: string;
  projectId: string;
}

export function DuplicateQuoteButton({
  pathToDocList,
  docId,
  projectId,
}: Props) {
  const { t } = useTranslate("Quote");

  const navigate = useNavigate();

  const { duplicate, loading: duplicateLoading } = useDuplicateQuote({
    projectId,
    quoteId: docId,
  });

  return (
    <MenuItemWithIcon
      icon={<FileCopyIcon />}
      onClick={async () => {
        const newQuoteId = await duplicate();
        if (newQuoteId) navigate(`${pathToDocList}/${newQuoteId}`);
      }}
      disabled={duplicateLoading}
    >
      {t("Duplicate quote")}
    </MenuItemWithIcon>
  );
}
